'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep3ConfirmFormComponent = exports.parcelAddStep3ConfirmFormComponent = {
    template: require('./parcel-add-step3-confirm-form.html'),
    bindings: {
        delivery: '<',
        submitStep3: '&',
        cancel: '&'
    },
    controllerAs: 'vm',
    controller: function parcelAddStep3ConfirmFormController() {
        'ngInject';

        var vm = this;

        vm.$onInit = init;
        vm.onSubmitStep3Form = onSubmitStep3Form;
        vm.onCancel = onCancel;
        vm.showError = false;
        vm.agreeWithTerms = false;

        function init() {
            resetForm();
        }

        function resetForm() {
            vm.agreeWithTerms = false;
            vm.showError = false;
        }

        function onSubmitStep3Form() {
            if (vm.agreeWithTerms) {
                vm.showError = false;
                vm.submitStep3();
            } else {
                vm.showError = true;
            }
        }

        function onCancel() {
            vm.cancel();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-add-step3-confirm-form.js
// module id = 874
// module chunks = 0